// SWIPER
import Swiper, {
    Navigation,
    FreeMode,
    Mousewheel,
    EffectFade,
    Autoplay,
} from "swiper";
Swiper.use([Navigation, FreeMode, Mousewheel, EffectFade, Autoplay]);
// import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/mousewheel";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";

// SUBNAV-SWIPER
let subnavSwiper;
const subnavSwiperEl = document.querySelector(".swiper.sub-nav");
if (subnavSwiperEl) {
    const centeredSlides = subnavSwiperEl.classList.contains("sw-center")
        ? true
        : false;
    subnavSwiper = new Swiper(subnavSwiperEl, {
        // Optional parameters
        direction: "horizontal",
        loop: false,
        //autoHeight: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        //observer: true,
        //a11y: true,
        centeredSlides: false,
        centeredSlidesBounds: true,
        mousewheel: true,
        //freeMode: true,
        freeMode: {
            enabled: true,
            minimumVelocity: 0.01,
            momentum: true,
            momentumBounce: false,
            momentumRatio: 0.5,
            momentumVelocityRatio: 1,
            sticky: false,
        },
    });

    window.onload = function() {
        subnavSwiper.params.centeredSlides = centeredSlides;
        subnavSwiper.update();
    };
}
export { subnavSwiper };

// SWIPERS
const swipers = document.querySelectorAll(".swiper.multi-slides");
swipers.forEach((swiperEl, index) => {
    let swiper = new Swiper(swiperEl, {
        // Optional parameters
        direction: "horizontal",
        loop: false,
        slidesPerView: "auto",
        spaceBetween: 12,
        observer: true,
        a11y: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 24,
                freeMode: false,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
            1600: {
                slidesPerView: 4,
                spaceBetween: 25,
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});

// Functions Swiper
const functionsSwipers = document.querySelectorAll(
    ".swiper.multi-slides-small"
);
functionsSwipers.forEach((swiperEl, index) => {
    let swiper = new Swiper(swiperEl, {
        // Optional parameters
        direction: "horizontal",
        loop: false,
        autoHeight: true,
        slidesPerView: "auto",
        //spaceBetween: 0,
        observer: true,
        a11y: true,
    });
    const numSlides = swiper.$el[0].querySelectorAll(".swiper-slide").length;

    //swiperEl.addEventListener("mousemove", handleMousemove, false);
    let scrollSlider = false;
    let timer = null;

    swiperEl.addEventListener("mouseleave", (event) => {
        scrollSlider = false;
    });

    swiperEl.addEventListener("mousemove", (event) => {
        const edgeSize = 150;
        const maxStep = 2;
        const viewportX = event.clientX;

        const swiperEl = event.target.closest(".swiper");
        const wrapper = swiperEl.querySelector(".swiper-wrapper");
        const rect = swiperEl.getBoundingClientRect();

        const edgeLeft = Math.round(rect.x + edgeSize);
        const edgeRight = Math.round(rect.x + rect.width - edgeSize);

        var isInLeftEdge = viewportX < edgeLeft;
        var isInRightEdge = viewportX > edgeRight;

        if (!(isInLeftEdge || isInRightEdge)) {
            //clearTimeout(timer);
            scrollSlider = false;
            return;
        }

        scrollSlider = true;

        (function checkForScroll() {
            clearTimeout(timer);

            if (adjustScroll()) {
                timer = setTimeout(checkForScroll, 30);
            }
        })();
        //adjustScroll(isInLeftEdge, isInRightEdge);

        function adjustScroll() {
            const currentTranslate = swiper.translate;
            const maxTranslate = -(swiper.virtualSize - swiper.width);
            let nextTranslate = currentTranslate;

            if (isInLeftEdge) {
                if (nextTranslate > 0) return;
                var intensity = (edgeLeft - viewportX) / edgeSize;
                nextTranslate = nextTranslate + maxStep * intensity;

                wrapper.animate(
                    [
                        {
                            transform:
                                "translate3d(" +
                                currentTranslate +
                                "px, 0px, 0px)",
                        },
                        {
                            transform:
                                "translate3d(" +
                                nextTranslate +
                                "px, 0px, 0px)",
                        },
                    ],
                    {
                        duration: 30,
                    }
                );

                swiper.translate = nextTranslate;
                wrapper.style.transform =
                    "translate3d(" + nextTranslate + "px, 0px, 0px)";

                // Should we scroll right?
            } else if (isInRightEdge) {
                if (nextTranslate < maxTranslate) return;
                var intensity = (viewportX - edgeRight) / edgeSize;
                nextTranslate = nextTranslate - maxStep * intensity;

                wrapper.animate(
                    [
                        {
                            transform:
                                "translate3d(" +
                                currentTranslate +
                                "px, 0px, 0px)",
                        },
                        {
                            transform:
                                "translate3d(" +
                                nextTranslate +
                                "px, 0px, 0px)",
                        },
                    ],
                    {
                        duration: 30,
                    }
                );

                swiper.translate = nextTranslate;

                
                wrapper.style.transform =
                    "translate3d(" + nextTranslate + "px, 0px, 0px)";
            }

            if (scrollSlider) {
                setTimeout(() => {
                    adjustScroll();
                }, 30);
            }
        }
    });
});

// LOGO SWIPERS
const logoSwipers = document.querySelectorAll(".swiper.logo-swiper");
logoSwipers.forEach((swiperEl, index) => {
    let swiper = new Swiper(swiperEl, {
        // Optional parameters
        direction: "horizontal",
        loop: false,
        spaceBetween: 12,
        observer: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
    });
});

// Screenshot SWIPERS
const screenshotSwipers = document.querySelectorAll(".swiper.screenshot-slider");
screenshotSwipers.forEach((swiperEl, index) => {
    let swiper = new Swiper(swiperEl, {
        // Optional parameters
        direction: "horizontal",
        loop: true,
        spaceBetween: 12,
        observer: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
    });
});

/*
const subnavToggle = () => {};
document.addEventListener("DOMContentLoaded", subnavToggle);
*/
const subNavWrapper = document.querySelector(".sub-nav .swiper-wrapper");
const subNavBtn = document.querySelector("button.subnav-button");
if (subNavBtn) {
    subNavBtn.addEventListener("click", () => {
        if (subNavWrapper.classList.contains("expanded")) {
            subnavSwiper.enable();
            subNavWrapper.classList.remove("expanded");
            subNavWrapper.style.transitionDuration = "0ms";
            subNavWrapper.style.flexWrap = "";
            //subNavWrapper.style.transitionDuration = "500ms";

            const activeEl = subNavWrapper.querySelector("a.active");
            const parentEl = activeEl.parentElement;
            const index = [...parentEl.parentElement.children].indexOf(
                parentEl
            );

            setTimeout(() => {
                subnavSwiper.slideTo(index, 1000);
            }, 100);
        } else {
            subnavSwiper.disable();
            subNavWrapper.classList.add("expanded");
            subNavWrapper.style.transitionDuration = "100ms";

            setTimeout(() => {
                subNavWrapper.style.flexWrap = "wrap";
            }, 100);
        }
    });

    const breakpoint = window.matchMedia("(min-width:768px)");
    function breakpointChecker() {
        // if larger viewport
        if (breakpoint.matches === true) {
            subnavSwiper.slideTo(0);
            subnavSwiper.enable();
            // or/and do nothing
            return;
            // else if a small viewport
        } else if (breakpoint.matches === false) {
            subnavSwiper.slideTo(0);
            subnavSwiper.disable();
            subnavSwiper.update();
            subNavWrapper.style.transform = "";
            return;
        }
    }
    breakpointChecker();
    breakpoint.addListener(breakpointChecker);
}
